import { Grid, TextField, TextFieldProps, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { PropsFilter } from "../../models/api/props-filter";
import { TnALocationCodeRef } from "../../models/tna-location-codes/tna-location-code-ref";
import AutocompleteDropdown from "../../reusable-components/AutocompleteDropdown/AutocompleteDropdown";
import { TnALocationCodesApiService } from "../../services/tna-location-codes/tna-location-codes-api.service";
import { TNA_TRACK_LOCATION_TYPES } from "../../utils/constants/track-location-constants";

interface Props {
  tnALocationCodeOrName: string;
  tnALocationCode: TnALocationCodeRef | null;
  handleChangelocationInput: (tnALocationCodeOrName: string, tnALocationCode: TnALocationCodeRef | null) => void;
  locationTrackingTypeId: string;
  employeeId: string;
  onBlur?: () => void;
  textFieldProps?: TextFieldProps;
  textFieldCustomStyle?: React.CSSProperties;
  displayHint?: boolean;
  autoCompleteCustomStyle?: React.CSSProperties;
}
const AddEditClockingLocation = ({
  tnALocationCodeOrName,
  tnALocationCode,
  handleChangelocationInput,
  locationTrackingTypeId,
  employeeId,
  onBlur,
  textFieldProps,
  textFieldCustomStyle,
  displayHint,
  autoCompleteCustomStyle,
}: Props) => {
  const tRP = "components.add_edit_clocking_location";
  const { t } = useTranslation();

  const renderLocationInput = (): JSX.Element | null => {
    switch (locationTrackingTypeId) {
      case TNA_TRACK_LOCATION_TYPES.ALLOW_ANY_LOCATION:
        return (
          <Grid>
            {displayHint && <Typography>{`${t(`${tRP}.add_location_hint`)} :`}</Typography>}
            <TextField
              sx={{
                width: "150px",
                "& .MuiOutlinedInput-root": {
                  borderRadius: "5px", // change to any radius
                },
                ...(displayHint && { marginTop: "15px" }),
                ...textFieldCustomStyle,
              }}
              label={`${t(`${tRP}.enter_location_code`)}`}
              value={tnALocationCodeOrName}
              onChange={(e) => {
                const value = e.target.value;
                handleChangelocationInput(value ?? "", null);
              }}
              onBlur={onBlur}
              {...textFieldProps}
            />
          </Grid>
        );

      case TNA_TRACK_LOCATION_TYPES.ALLOW_ANY_WITH_FLAG:
        return (
          <Grid>
            {displayHint && <Typography>{`${t(`${tRP}.add_location_hint`)} :`}</Typography>}
            <TextField
              sx={{
                width: "150px",
                "& .MuiOutlinedInput-root": {
                  borderRadius: "5px", // change to any radius
                },
                ...(displayHint && { marginTop: "15px" }),
                ...textFieldCustomStyle,
              }}
              label={`${t(`${tRP}.enter_location_code`)}`}
              value={tnALocationCodeOrName}
              onChange={(e) => {
                const value = e.target.value;
                handleChangelocationInput(value ?? "", null);
              }}
              onBlur={onBlur}
              {...textFieldProps}
            />
          </Grid>
        );
      case TNA_TRACK_LOCATION_TYPES.ALLOW_ONLY_PREDEFINED:
        return (
          <AutocompleteDropdown
            labelKey={`${tRP}.select_location_code`}
            field="tnALocationCode"
            handleChange={(field, value) => handleChangelocationInput("", value)}
            serviceApi={new TnALocationCodesApiService()}
            required={true}
            selectedValue={tnALocationCode}
            sxProps={{ width: "100%", onBlur, size: "small" }}
            propsFilter={{ employeeId } as PropsFilter}
            textFieldProps={{ ...textFieldProps }}
            inputStyle={{ borderRadius: "5px", width: "150px", ...autoCompleteCustomStyle }}
          />
        );
      default:
        return null;
    }
  };
  return <>{renderLocationInput()}</>;
};

export default AddEditClockingLocation;
